/**
 * @generated SignedSource<<bb903549387dec9eba460bcd16603cb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductFamily = "BUSINESS" | "ENTERPRISE" | "ENTERPRISE_PLUS" | "FEEDBACK" | "FREE" | "MEETING_RECORDER" | "OBJECTIVES" | "PRO" | "SOLOPRENEUR";
export type SubscriptionState = "POST_SUBSCRIBED" | "POST_TRIAL" | "SUBSCRIBED" | "TRIAL";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
export type CompanionModeQuery$variables = {
  noteId: string;
};
export type CompanionModeQuery$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
    readonly allowDelegatedAccess: boolean;
    readonly allowInviting: boolean | null;
    readonly allowMeetingRecording: boolean;
    readonly billingAccount: {
      readonly customerDelinquent: boolean | null;
      readonly hasAccessToMeetingBriefs: boolean;
      readonly hasAccessToObjectives: boolean;
      readonly id: string;
      readonly isOverUserLimit: boolean;
      readonly isSubscriptionActive: boolean;
      readonly paymentInformationExpired: boolean;
      readonly paymentInformationOnFile: boolean;
      readonly product: {
        readonly family: ProductFamily;
        readonly legacy: boolean;
      };
      readonly subscriptionPeriodEnd: string | null;
      readonly subscriptionProductName: string;
      readonly subscriptionStartDate: string | null;
      readonly subscriptionState: SubscriptionState;
      readonly subscriptionTrialEnd: string | null;
      readonly userLimit: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"BillingFeatureRefresher_billingAccount">;
    };
    readonly developerApiEnabled: boolean;
    readonly hrisIntegrated: boolean | null;
    readonly id: string;
    readonly integrations: {
      readonly gsuite: {
        readonly delegated: boolean;
        readonly id: string;
      } | null;
      readonly office365: {
        readonly adminConsented: boolean;
        readonly id: string;
      } | null;
    };
    readonly isPersonalType: boolean;
    readonly logo: string;
    readonly name: string;
    readonly subdomain: string;
    readonly uri: string;
  };
  readonly note: {
    readonly __typename: "Note";
    readonly id: string;
    readonly stream: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Bookmarks_stream" | "SeriesSidePanel_allowedTabs_stream">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"Notes_note">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly user: {
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly internalAttributes: {
      readonly dateConfigured: string | null;
      readonly firstWeekDay: string | null;
      readonly isAccountAdmin: boolean;
      readonly isManager: boolean;
      readonly isOrganizationManager: boolean;
      readonly manager: {
        readonly id: string;
      } | null;
    } | null;
    readonly isConfigured: boolean;
    readonly isGuest: boolean;
    readonly isTopUser: boolean;
    readonly lastName: string;
    readonly timezones: {
      readonly preferredTimezone: {
        readonly timezone: {
          readonly description: string;
          readonly name: string;
          readonly utcOffset: number;
        };
      };
    };
    readonly type: UserType;
  };
  readonly viewer: {
    readonly hasAccessToCopilot: boolean;
    readonly hasAdminAccess: boolean;
    readonly settings: {
      readonly theme: string | null;
    };
    readonly uxSimplificationEnabled: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"Notes_viewer" | "SeriesSidePanel_allowedTabs_viewer">;
  };
};
export type CompanionModeQuery = {
  response: CompanionModeQuery$data;
  variables: CompanionModeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subdomain",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hrisIntegrated",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInviting",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPersonalType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowAiFeatures",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowMeetingRecording",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowDelegatedAccess",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developerApiEnabled",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSubscriptionActive",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionState",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionStartDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionTrialEnd",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionProductName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionPeriodEnd",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOverUserLimit",
  "storageKey": null
},
v20 = {
  "alias": "userLimit",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "users"
    }
  ],
  "kind": "ScalarField",
  "name": "usageLimitForFeature",
  "storageKey": "usageLimitForFeature(feature:\"users\")"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentInformationExpired",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentInformationOnFile",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerDelinquent",
  "storageKey": null
},
v24 = {
  "alias": "hasAccessToMeetingBriefs",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "meeting_briefs"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"meeting_briefs\")"
},
v25 = {
  "alias": "hasAccessToObjectives",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "objectives"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"objectives\")"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "family",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legacy",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GSuiteAccountNode",
      "kind": "LinkedField",
      "name": "gsuite",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delegated",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeAccountNode",
      "kind": "LinkedField",
      "name": "office365",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminConsented",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "TimezonePreferences",
  "kind": "LinkedField",
  "name": "timezones",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTimezone",
      "kind": "LinkedField",
      "name": "preferredTimezone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeZone",
          "kind": "LinkedField",
          "name": "timezone",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "utcOffset",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateConfigured",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstWeekDay",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountAdmin",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isManager",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrganizationManager",
  "storageKey": null
},
v44 = [
  (v1/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAdminAccess",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToCopilot",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theme",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureAccess",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v55 = [
  (v54/*: any*/),
  (v1/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v57 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "hubspot_integration"
  }
],
v58 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "salesforce_integration"
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowRecapEngagementStats",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoUrl",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavourite",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "context",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptChapter",
  "kind": "LinkedField",
  "name": "chapters",
  "plural": true,
  "selections": [
    (v67/*: any*/),
    (v61/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptBulletPoint",
      "kind": "LinkedField",
      "name": "bulletPoints",
      "plural": true,
      "selections": [
        (v68/*: any*/),
        (v67/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textShort",
          "storageKey": null
        },
        (v69/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptActionItem",
  "kind": "LinkedField",
  "name": "actionItems",
  "plural": true,
  "selections": [
    (v67/*: any*/),
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptActionItemAssignee",
      "kind": "LinkedField",
      "name": "assignees",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedBlockKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edited",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "TranscriptDecision",
  "kind": "LinkedField",
  "name": "decisions",
  "plural": true,
  "selections": [
    (v67/*: any*/),
    (v68/*: any*/),
    (v69/*: any*/)
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanEdit",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoPosterUrl",
  "storageKey": null
},
v77 = [
  (v1/*: any*/),
  (v31/*: any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTimestamp",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTimestamp",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    (v31/*: any*/),
    (v29/*: any*/),
    (v37/*: any*/),
    (v82/*: any*/)
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detectedLanguage",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "languageConfidenceScore",
  "storageKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecording",
          "kind": "LinkedField",
          "name": "baseRecording",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecordingParticipant",
              "kind": "LinkedField",
              "name": "allRelevantParticipants",
              "plural": true,
              "selections": [
                (v31/*: any*/),
                (v30/*: any*/),
                (v29/*: any*/),
                (v37/*: any*/),
                (v82/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MeetingRecordingClip",
      "abstractKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInternalAttributes",
  "kind": "LinkedField",
  "name": "internalAttributes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invitable",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalBlockId",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schemaVersion",
  "storageKey": null
},
v102 = [
  (v1/*: any*/),
  (v32/*: any*/),
  (v31/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isViewer",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanionModeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BillingFeatureRefresher_billingAccount"
              }
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v45/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeriesSidePanel_allowedTabs_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Notes_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v50/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SeriesSidePanel_allowedTabs_stream"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Bookmarks_stream"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Notes_note"
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanionModeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v52/*: any*/),
              (v53/*: any*/)
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v45/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v1/*: any*/),
          (v49/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubspotUserNode",
                "kind": "LinkedField",
                "name": "hubspot",
                "plural": false,
                "selections": (v55/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesforceUserNode",
                "kind": "LinkedField",
                "name": "salesforce",
                "plural": false,
                "selections": [
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enhancedNotesEnabled",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": (v55/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasLocalRecordingTokenScope",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleUserNode",
                "kind": "LinkedField",
                "name": "google",
                "plural": false,
                "selections": [
                  (v56/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailDomainList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userConnected",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraAccountNode",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToHubspotFeature",
                    "args": (v57/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
                  },
                  {
                    "alias": "hasAccessToSalesforceFeature",
                    "args": (v58/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
                  },
                  (v1/*: any*/),
                  {
                    "alias": "hasCopilotAddon",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_recorder"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  },
                  {
                    "alias": "hasAccessToRecapTemplates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_templates"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_templates\")"
                  },
                  {
                    "alias": "hasAccessToDuedates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "duedates"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"duedates\")"
                  },
                  {
                    "alias": "hasAccessToVersioning",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "versioning"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"versioning\")"
                  },
                  {
                    "alias": "hasAccessToSharing",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "sharing"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"sharing\")"
                  },
                  {
                    "alias": "hasAccessToJiraIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "jira_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"jira_integration\")"
                  },
                  {
                    "alias": "hasAccessToComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"comments\")"
                  },
                  {
                    "alias": "hasAccessToMeetingFeedback",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_feedback"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_feedback\")"
                  },
                  {
                    "alias": "hasAccessToNoteLocking",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "note_locking"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"note_locking\")"
                  },
                  {
                    "alias": "hasAccessToZapierIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "zapier_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
                  },
                  {
                    "alias": "hasAccessToEmbeds",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "embeds"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"embeds\")"
                  },
                  {
                    "alias": "hasAccessToSalesforce",
                    "args": (v58/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
                  },
                  {
                    "alias": "hasAccessToHubspot",
                    "args": (v57/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
                  },
                  {
                    "alias": "hasAccessToAsana",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "asana_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
                  },
                  (v25/*: any*/),
                  {
                    "alias": "hasAccessToPromptHeadings",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "prompt_headings"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
                  },
                  {
                    "alias": "hasAccessToNotesIntegrationExport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "notes_integration_export"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
                  },
                  {
                    "alias": "hasAccessToMultipleAssignees",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "multiple_assignees"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"multiple_assignees\")"
                  },
                  (v52/*: any*/),
                  {
                    "alias": "hasAccessToRedaction",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "redaction"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"redaction\")"
                  },
                  {
                    "alias": "hasAccessToRecapComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_comments\")"
                  },
                  {
                    "alias": "hasAccessToPrivateRecapComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_private_comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_private_comments\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              (v10/*: any*/),
              (v51/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loomEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v51/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowMeetingRecordingRedaction",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountUploadCredits",
                "kind": "LinkedField",
                "name": "uploadCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedUploadCredits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedCreditsUsedCurrentCycle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowRecapDownload",
                "storageKey": null
              },
              (v59/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingMeetingRecordingCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToScheduledMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v36/*: any*/),
              (v32/*: any*/),
              (v31/*: any*/),
              (v29/*: any*/),
              (v60/*: any*/),
              (v37/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserMeetingRecapAutoShareSettings",
            "kind": "LinkedField",
            "name": "meetingRecapAutoShareSettings",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendTo",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "connectedActionItemIntegrations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedBrowserExtension",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateWorkspaceTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "playbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitlesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volume",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v50/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v60/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "notestreamusers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "claimedEvents",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "attendees",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteWithRecordingExists",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "askCopilotConversationExists",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamTabNode",
                    "kind": "LinkedField",
                    "name": "tabs",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "otherStreamId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v61/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "order",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isEmbedded",
                        "storageKey": null
                      },
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schedulingMeetingAssistantAutomationIsActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingRecapAutoShareSource",
                    "plural": false,
                    "selections": [
                      (v51/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "sendTo_S",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          }
                        ],
                        "type": "StreamMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "sendTo_U",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          }
                        ],
                        "type": "UserMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      (v63/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingVideoAndTranscriptionDownloadUrl",
                    "storageKey": null
                  },
                  (v64/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subtitlesVttUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailVttUrl",
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanDelete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalAttendees",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcript",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcriptDeletionReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCurrentlyRecording",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingSummary",
                    "kind": "LinkedField",
                    "name": "activeSummary",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v66/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activeRecapTemplate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templatedRecaps",
                        "storageKey": null
                      },
                      (v73/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingPromptFeedback",
                        "kind": "LinkedField",
                        "name": "feedback",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "missingInformation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notFactuallyCorrect",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dontLikeTheTone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "other",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "otherFeedback",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingClip",
                    "kind": "LinkedField",
                    "name": "clips",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v61/*: any*/),
                      (v74/*: any*/),
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clipStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clipEnd",
                        "storageKey": null
                      },
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v77/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": (v77/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v51/*: any*/)
                        ],
                        "type": "MeetingRecordingInterface",
                        "abstractKey": "__isMeetingRecordingInterface"
                      }
                    ],
                    "storageKey": null
                  },
                  (v51/*: any*/),
                  (v62/*: any*/),
                  (v74/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGeneratingRecapTemplate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "redactionIsInProgress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "regenerationForLanguageIsInProgress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAskCopilotConversation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingAndTranscriptWillBeDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordingVideoDeletionReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingDataAutoDeletionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userVideoProgress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ownerAccount",
                    "plural": false,
                    "selections": [
                      (v51/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v51/*: any*/),
                      (v61/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingKeyEvent",
                    "kind": "LinkedField",
                    "name": "meetingKeyEvents",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "participantName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeFromRecordingStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endTimeFromRecordingStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "duration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingCommentsData",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "threadId",
                        "storageKey": null
                      },
                      (v78/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SmartTrackerResult",
                    "kind": "LinkedField",
                    "name": "smartTrackers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trackerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SmartTrackerMatch",
                        "kind": "LinkedField",
                        "name": "matches",
                        "plural": true,
                        "selections": [
                          (v78/*: any*/),
                          (v79/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showLowLanguageConfidenceRegenerationBanner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canRegenerateSummary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingStats",
                    "kind": "LinkedField",
                    "name": "meetingStats",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingStatsUser",
                        "kind": "LinkedField",
                        "name": "userStats",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v29/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "absent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTalkTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "joinedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leftAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualStartTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualEndTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecordingSummary",
                    "kind": "LinkedField",
                    "name": "summaries",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v66/*: any*/),
                      (v73/*: any*/),
                      (v71/*: any*/),
                      (v70/*: any*/),
                      (v72/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v31/*: any*/),
                          (v30/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v80/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalRecordingProvider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "userWhoStartedRecording",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v73/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "transcriptTxtDownloadUrl",
                        "storageKey": null
                      },
                      (v76/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewCount",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecordingCommentsData",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                              (v79/*: any*/),
                              (v81/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "users",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v29/*: any*/),
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v83/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "didViewerAttend",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aiArtifactsTxtDownloadUrl",
                            "storageKey": null
                          },
                          (v86/*: any*/)
                        ],
                        "type": "MeetingRecording",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecording",
                            "kind": "LinkedField",
                            "name": "baseRecording",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v83/*: any*/),
                              (v86/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MeetingRecordingClip",
                        "abstractKey": null
                      }
                    ],
                    "type": "MeetingRecordingInterface",
                    "abstractKey": "__isMeetingRecordingInterface"
                  }
                ],
                "storageKey": null
              },
              (v53/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v61/*: any*/),
                  (v80/*: any*/),
                  (v87/*: any*/),
                  (v88/*: any*/),
                  (v89/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConferenceCall",
                    "kind": "LinkedField",
                    "name": "conferenceCalls",
                    "plural": true,
                    "selections": [
                      (v90/*: any*/),
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasUsersWithExternalEmail",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventGuid",
                "storageKey": null
              },
              (v62/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v51/*: any*/),
                  (v9/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecordingErrorIndicator",
                "kind": "LinkedField",
                "name": "recordingErrorIndicator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "cancelledBy",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v31/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorType",
                    "storageKey": null
                  },
                  (v91/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasMeetingRecordings",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v75/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isLocked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteUser",
                        "kind": "LinkedField",
                        "name": "noteuserSet",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v36/*: any*/),
                              (v29/*: any*/),
                              (v51/*: any*/),
                              (v35/*: any*/),
                              (v32/*: any*/),
                              (v56/*: any*/),
                              (v34/*: any*/),
                              (v37/*: any*/),
                              (v60/*: any*/),
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastSeenAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "event",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "organizer",
                            "plural": false,
                            "selections": (v44/*: any*/),
                            "storageKey": null
                          },
                          (v93/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willBeRecorded",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConferenceCall",
                            "kind": "LinkedField",
                            "name": "mainConferenceCall",
                            "plural": false,
                            "selections": [
                              (v90/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v61/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rawDraftJson",
                        "storageKey": null
                      },
                      (v91/*: any*/),
                      (v73/*: any*/),
                      (v94/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "collapsedBlockKeys",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canUnlockNote",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteCommentsData",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "blockKey",
                            "storageKey": null
                          },
                          (v81/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v31/*: any*/),
                              (v29/*: any*/),
                              (v60/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reactions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attachment",
                        "kind": "LinkedField",
                        "name": "attachments",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageDimensions",
                            "kind": "LinkedField",
                            "name": "dimensions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "filename",
                            "storageKey": null
                          },
                          (v91/*: any*/),
                          {
                            "alias": "directUrl",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "size",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "filetype",
                            "storageKey": null
                          },
                          (v62/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v29/*: any*/),
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "externalUsers",
                        "plural": true,
                        "selections": [
                          (v51/*: any*/),
                          (v1/*: any*/),
                          (v35/*: any*/),
                          (v30/*: any*/),
                          (v32/*: any*/),
                          (v31/*: any*/),
                          (v29/*: any*/),
                          (v56/*: any*/),
                          (v34/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v60/*: any*/),
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "linkedActionItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "linkedOnly",
                            "value": true
                          }
                        ],
                        "concreteType": "NoteBlock",
                        "kind": "LinkedField",
                        "name": "actionItems",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasOriginalBlock",
                            "storageKey": null
                          },
                          (v95/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteBlock",
                            "kind": "LinkedField",
                            "name": "originalBlock",
                            "plural": false,
                            "selections": [
                              (v96/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": "actionItems(linkedOnly:true)"
                      },
                      {
                        "alias": "asanaActionItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "asanaOnly",
                            "value": true
                          }
                        ],
                        "concreteType": "NoteBlock",
                        "kind": "LinkedField",
                        "name": "actionItems",
                        "plural": true,
                        "selections": [
                          {
                            "alias": "blockId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": "blockKey",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AsanaBlockLinkNode",
                            "kind": "LinkedField",
                            "name": "asanablocklink",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AsanaProjectNode",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v97/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v97/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": "actionItems(asanaOnly:true)"
                      },
                      {
                        "alias": "integrationLinkedActionItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "integrationConnectedOnly",
                            "value": true
                          }
                        ],
                        "concreteType": "NoteBlock",
                        "kind": "LinkedField",
                        "name": "actionItems",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v96/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActionItemIntegrationLinkNode",
                            "kind": "LinkedField",
                            "name": "actionItemIntegrationLink",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteBlock",
                                "kind": "LinkedField",
                                "name": "actionItem",
                                "plural": false,
                                "selections": [
                                  (v95/*: any*/),
                                  (v1/*: any*/),
                                  (v96/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v73/*: any*/),
                              (v91/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "syncStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastSyncedError",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "integrationProvider",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "integrationData",
                                "plural": false,
                                "selections": [
                                  (v51/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v98/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "listName",
                                        "storageKey": null
                                      },
                                      (v80/*: any*/),
                                      (v99/*: any*/)
                                    ],
                                    "type": "ClickupActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalCardId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "boardName",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "TrelloActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v98/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalGroupName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalBoardId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalBoardName",
                                        "storageKey": null
                                      },
                                      (v80/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MondayUserNode",
                                        "kind": "LinkedField",
                                        "name": "mondayUser",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "accountSlug",
                                            "storageKey": null
                                          },
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MondayActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalIdentifier",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "statusName",
                                        "storageKey": null
                                      },
                                      (v99/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LinearUserNode",
                                        "kind": "LinkedField",
                                        "name": "linearUser",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v54/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "organizationUrlKey",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LinearActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v98/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalListId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalListName",
                                        "storageKey": null
                                      },
                                      (v80/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MicrosoftTodoUserNode",
                                        "kind": "LinkedField",
                                        "name": "microsoftTodoUser",
                                        "plural": false,
                                        "selections": (v55/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v98/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hubspotUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                                    "abstractKey": null
                                  },
                                  (v63/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "actionItems(integrationConnectedOnly:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteStream",
                        "kind": "LinkedField",
                        "name": "stream",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "account",
                            "plural": false,
                            "selections": [
                              (v51/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": "image",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logo",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteStream",
                            "kind": "LinkedField",
                            "name": "relatedStreams",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "account",
                                "plural": false,
                                "selections": [
                                  (v51/*: any*/),
                                  (v2/*: any*/),
                                  (v1/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v100/*: any*/),
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v100/*: any*/),
                          (v62/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "nextEvent",
                            "plural": false,
                            "selections": [
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteTemplateNode",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v75/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visibility",
                                "storageKey": null
                              },
                              (v61/*: any*/),
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "proseDoc",
                                "storageKey": null
                              },
                              (v101/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tags",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteStreamUser",
                            "kind": "LinkedField",
                            "name": "notestreamusers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  (v32/*: any*/),
                                  (v56/*: any*/),
                                  (v34/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasReceivedInvites",
                                    "storageKey": null
                                  },
                                  (v37/*: any*/),
                                  (v60/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "account",
                                    "plural": false,
                                    "selections": [
                                      (v51/*: any*/),
                                      (v1/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accessType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkedEventGuid",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "linkedEvent",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "nextOccurrence",
                                "plural": false,
                                "selections": [
                                  (v87/*: any*/),
                                  (v88/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "finalOccurrence",
                                "storageKey": null
                              },
                              (v1/*: any*/),
                              (v93/*: any*/),
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recurrenceRule",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "otherUser",
                            "plural": false,
                            "selections": (v77/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v44/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recordingMediaType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recordingMode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "autoRecordSetting",
                            "plural": false,
                            "selections": [
                              (v51/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "value",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": (v102/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "NoteStreamStreamBasedAutoRecordSource",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": (v102/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AutoRecordRule",
                                    "kind": "LinkedField",
                                    "name": "rules",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "ruleLevel",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AutoRecordRuleUser",
                                        "kind": "LinkedField",
                                        "name": "autoRecordRuleUsers",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v102/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cannotBeRecordedReason",
                                    "storageKey": null
                                  }
                                ],
                                "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecording",
                        "kind": "LinkedField",
                        "name": "meetingRecordings",
                        "plural": true,
                        "selections": [
                          (v84/*: any*/),
                          (v85/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasTranscript",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "noteType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "previousNote",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v73/*: any*/),
                          (v94/*: any*/),
                          (v62/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v89/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pendingAgendaCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pendingTodoCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingLink",
                        "kind": "LinkedField",
                        "name": "meetingRecordingLink",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": "urlForCopy",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "forCopy",
                                "value": true
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(forCopy:true)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortUrl",
                        "storageKey": null
                      },
                      {
                        "alias": "noteTitle",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "version",
                        "storageKey": null
                      },
                      (v101/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Note",
                    "abstractKey": null
                  }
                ],
                "type": "INote",
                "abstractKey": "__isINote"
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca45e58a187fb80db376b94bd8274db5",
    "id": null,
    "metadata": {},
    "name": "CompanionModeQuery",
    "operationKind": "query",
    "text": "query CompanionModeQuery(\n  $noteId: ID!\n) {\n  account {\n    id\n    name\n    logo\n    subdomain\n    uri\n    hrisIntegrated\n    allowInviting\n    isPersonalType\n    allowAiFeatures\n    allowMeetingRecording\n    allowDelegatedAccess\n    developerApiEnabled\n    billingAccount {\n      id\n      isSubscriptionActive\n      subscriptionState\n      subscriptionStartDate\n      subscriptionTrialEnd\n      subscriptionProductName\n      subscriptionPeriodEnd\n      isOverUserLimit\n      userLimit: usageLimitForFeature(feature: users)\n      paymentInformationExpired\n      paymentInformationOnFile\n      customerDelinquent\n      hasAccessToMeetingBriefs: hasAccessToFeature(feature: meeting_briefs)\n      hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n      product {\n        family\n        legacy\n        id\n      }\n      ...BillingFeatureRefresher_billingAccount\n    }\n    integrations {\n      gsuite {\n        id\n        delegated\n      }\n      office365 {\n        id\n        adminConsented\n      }\n    }\n  }\n  user {\n    id\n    image\n    email\n    fullName\n    firstName\n    lastName\n    isConfigured\n    type\n    isGuest\n    isTopUser\n    timezones {\n      preferredTimezone {\n        timezone {\n          name\n          description\n          utcOffset\n        }\n      }\n    }\n    internalAttributes {\n      dateConfigured\n      firstWeekDay\n      isAccountAdmin\n      isManager\n      isOrganizationManager\n      manager {\n        id\n      }\n      id\n    }\n  }\n  viewer {\n    hasAdminAccess\n    hasAccessToCopilot\n    uxSimplificationEnabled\n    id\n    settings {\n      theme\n    }\n    ...SeriesSidePanel_allowedTabs_viewer\n    ...Notes_viewer\n  }\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      id\n      stream {\n        id\n        ...SeriesSidePanel_allowedTabs_stream\n        ...Bookmarks_stream\n      }\n      ...Notes_note\n    }\n    id\n  }\n}\n\nfragment AddNoteTitle_note on Note {\n  id\n  isLocked\n  noteTitle: title\n  stream {\n    displayName\n    id\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment ApplyTemplate_note on Note {\n  id\n  version\n  isLocked\n  stream {\n    isExternal\n    id\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment AskFellowHooks_useAskFellowButton_note on Note {\n  id\n}\n\nfragment AttachmentPreviewAttachment on Attachment {\n  id\n  filename\n  updatedAt\n  directUrl: url\n  size\n  dimensions {\n    width\n    height\n  }\n  filetype\n}\n\nfragment AttachmentsRelay_note on Note {\n  id\n  attachments {\n    id\n    filename\n    updatedAt\n    url\n    size\n    filetype\n    creator {\n      id\n      image\n      fullName\n    }\n    dimensions {\n      width\n      height\n    }\n  }\n}\n\nfragment Attendees_note on Note {\n  noteuserSet {\n    user {\n      id\n      fullName\n      image\n      isExternal\n      isGuest\n      isTopUser\n    }\n    id\n  }\n}\n\nfragment Attendees_viewer on Viewer {\n  user {\n    id\n    fullName\n    image\n    isExternal\n    isGuest\n    isTopUser\n  }\n}\n\nfragment AutoRecordToggle_note on Note {\n  stream {\n    id\n    ...AutoRecordToggle_refetchableAutoRecordReason\n    ...AutoRecordToggle_refetchableAutoRecordIsOnForStream\n  }\n  event {\n    hasUsersWithExternalEmail\n    willBeRecorded\n    id\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment AutoRecordToggle_refetchableAutoRecordIsOnForStream on NoteStream {\n  schedulingMeetingAssistantAutomationIsActive\n  id\n}\n\nfragment AutoRecordToggle_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment AutoRecordToggle_viewer on Viewer {\n  meetingRecapAutoShareSettings {\n    sendTo\n    id\n  }\n}\n\nfragment AutoSendToEveryone_autoShareIsSetToEveryone_note on Note {\n  stream {\n    meetingRecapAutoShareSource {\n      __typename\n      ... on StreamMeetingRecapAutoShareSettings {\n        sendTo_S: sendTo\n      }\n      ... on UserMeetingRecapAutoShareSettings {\n        sendTo_U: sendTo\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment BillingFeatureRefresher_billingAccount on BillingAccount {\n  id\n  featureAccess\n  groupName\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment Bookmarks_stream on NoteStream {\n  id\n  tabs {\n    id\n    otherStreamId\n    icon\n    title\n    order\n    isEmbedded\n    url\n  }\n}\n\nfragment CarryForward_MoreActionsMenu_note on Note {\n  id\n  previousNote {\n    pendingAgendaCount\n    pendingTodoCount\n    id\n  }\n}\n\nfragment ChaptersPanel_meetingRecording on MeetingRecording {\n  id\n  activeSummary {\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    id\n  }\n  userVideoProgress\n}\n\nfragment ClipCutModal_meetingRecording on MeetingRecording {\n  __typename\n  id\n  transcript\n  meetingRecordedVideoDuration\n  meetingRecordedVideoUrl\n  subtitlesVttUrl\n  thumbnailVttUrl\n  ownerAccount {\n    __typename\n    id\n  }\n  note {\n    __typename\n    title\n    id\n  }\n  ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n  ...TranscriptVideo_meetingRecording_1DbIRQ\n}\n\nfragment ClipsPanel_ClipCard_clip on MeetingRecordingClip {\n  id\n  title\n  viewerCanEdit\n  meetingRecordedVideoDuration\n  meetingRecordedVideoPosterUrl\n  meetingRecordedVideoUrl\n  summary\n  isFavourite\n  creator {\n    id\n    fullName\n  }\n  lastEditedBy {\n    id\n    fullName\n  }\n  ...utils_useGetURL_recording\n  ...ClipsPanel_RenameClipModal_clip\n  ...ClipsPanel_DeleteClipModal_clip\n}\n\nfragment ClipsPanel_ClipSummary_clip on MeetingRecordingClip {\n  id\n  title\n  meetingRecordedVideoDuration\n  summary\n}\n\nfragment ClipsPanel_DeleteClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_meetingRecording on MeetingRecording {\n  id\n  clips {\n    id\n    ...ClipsPanel_ClipCard_clip\n  }\n}\n\nfragment DeleteMeeting_note on Note {\n  id\n  viewerCanEdit\n  isLocked\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n  ...DeleteNoteModal_note\n}\n\nfragment DeleteMeeting_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n}\n\nfragment DeleteNoteModal_note on Note {\n  id\n  title\n  eventStart\n  eventEnd\n  createdAt\n  meetingRecordings {\n    id\n    hasTranscript\n    meetingRecordedVideoUrl\n    clips {\n      id\n      title\n    }\n  }\n  stream {\n    id\n  }\n}\n\nfragment DislikeModal_meetingRecording on MeetingRecording {\n  id\n  canRegenerateSummary\n  activeSummary {\n    id\n    feedback {\n      id\n      missingInformation\n      notFactuallyCorrect\n      dontLikeTheTone\n      other\n      otherFeedback\n    }\n  }\n}\n\nfragment EditLinkedEvent_note on Note {\n  stream {\n    ...LinkEventModal_stream\n    id\n  }\n}\n\nfragment EditTemplateMenuItem_note on Note {\n  id\n  version\n  isLocked\n  stream {\n    id\n    template {\n      id\n      viewerCanEdit\n      visibility\n      title\n      summary\n      proseDoc\n      schemaVersion\n      tags\n    }\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment ExportMenuItem_note on Note {\n  stream {\n    ...ExportToDocs_stream\n    id\n  }\n}\n\nfragment ExportMenuItem_viewer on Viewer {\n  integrations {\n    google {\n      isActive\n      id\n    }\n  }\n  user {\n    isGuest\n    id\n  }\n  ...ExportToDocs_viewer\n}\n\nfragment ExportToDocs_stream on NoteStream {\n  id\n  displayName\n}\n\nfragment ExportToDocs_viewer on Viewer {\n  uxSimplificationEnabled\n  account {\n    billingAccount {\n      hasAccessToNotesIntegrationExport: hasAccessToFeature(feature: notes_integration_export)\n      id\n    }\n    id\n  }\n}\n\nfragment FloatingRecordingControls_note on Note {\n  id\n  ...PreMeetingControls_note\n  ...AskFellowHooks_useAskFellowButton_note\n}\n\nfragment HighlightsPanel_DecisionsHighlight_decisions on TranscriptDecision {\n  timestamp\n  text\n  context\n}\n\nfragment HighlightsPanel_meetingRecording_1DbIRQ on MeetingRecording {\n  __typename\n  id\n  hasExternalAttendees\n  activeSummary {\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    decisions {\n      ...HighlightsPanel_DecisionsHighlight_decisions\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        timestamp\n        text\n        textShort\n        context\n      }\n    }\n    templatedRecaps\n    activeRecapTemplate\n    id\n  }\n  title\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  recordingDataAutoDeletionDate\n  meetingRecordedVideoDuration\n  ...utils_AddedOrAvailableUntil_meetingRecording\n  userVideoProgress\n  smartTrackers {\n    trackerName\n    matches {\n      startTimestamp\n      endTimestamp\n    }\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  showLowLanguageConfidenceRegenerationBanner\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment HighlightsPanel_note on Note {\n  id\n  title\n  isLocked\n  viewerCanEdit\n}\n\nfragment HighlightsPanel_viewer on Viewer {\n  account {\n    __typename\n    allowAiFeatures\n    billingAccount {\n      hasAccessToRecapTemplates: hasAccessToFeature(feature: recap_templates)\n      id\n    }\n    id\n  }\n}\n\nfragment JoinConferenceButton_event on Event {\n  guid\n  conferenceCalls {\n    provider\n    url\n  }\n}\n\nfragment JoinConferenceButton_viewer on Viewer {\n  uxSimplificationEnabled\n  lastUsedBrowserExtension\n  integrations {\n    zoom {\n      isConnected\n      hasLocalRecordingTokenScope\n      id\n    }\n  }\n}\n\nfragment LinkEventModal_stream on NoteStream {\n  ...useEventState_stream\n  id\n  otherUser {\n    id\n    fullName\n  }\n  linkedEvent {\n    id\n    guid\n    title\n    recurrenceRule\n    nextOccurrence {\n      start\n      end\n      id\n    }\n    finalOccurrence\n  }\n}\n\nfragment LockNote_note on Note {\n  id\n  isLocked\n  canUnlockNote\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment LockNote_viewer on Viewer {\n  account {\n    billingAccount {\n      hasAccessToNoteLocking: hasAccessToFeature(feature: note_locking)\n      id\n    }\n    id\n  }\n}\n\nfragment MeetingContainerModalNote_note on Note {\n  id\n  title\n  url\n  eventGuid\n  rawDraftJson\n  updatedAt\n  createdAt\n  eventStart\n  eventEnd\n  finished\n  collapsedBlockKeys\n  isLocked\n  canUnlockNote\n  groupName\n  viewerCanEdit\n  comments {\n    blockKey\n    count\n    users {\n      id\n      fullName\n      image\n      isExternal\n    }\n  }\n  reactions\n  attachments {\n    id\n    dimensions {\n      height\n      width\n    }\n    ...AttachmentPreviewAttachment\n  }\n  noteuserSet {\n    id\n    lastSeenAt\n    user {\n      __typename\n      id\n      type\n      email\n      firstName\n      fullName\n      image\n      isActive\n      isConfigured\n      isGuest\n      isTopUser\n      isExternal\n      internalAttributes {\n        invitable\n        id\n      }\n    }\n  }\n  externalUsers {\n    __typename\n    id\n    type\n    email\n    firstName\n    fullName\n    image\n    isActive\n    isConfigured\n    isGuest\n    isTopUser\n    isExternal\n    internalAttributes {\n      invitable\n      id\n    }\n  }\n  linkedActionItems: actionItems(linkedOnly: true) {\n    hasOriginalBlock\n    originalBlockId\n    originalBlock {\n      key\n      id\n    }\n    id\n  }\n  asanaActionItems: actionItems(asanaOnly: true) {\n    blockId: id\n    blockKey: key\n    asanablocklink {\n      id\n      project {\n        id\n        name\n        externalId\n      }\n      externalId\n    }\n    id\n  }\n  integrationLinkedActionItems: actionItems(integrationConnectedOnly: true) {\n    id\n    key\n    actionItemIntegrationLink {\n      id\n      actionItem {\n        originalBlockId\n        id\n        key\n      }\n      createdAt\n      updatedAt\n      syncStatus\n      lastSyncedError\n      integrationProvider\n      integrationData {\n        __typename\n        ... on ClickupActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          listName\n          status\n          statusColor\n        }\n        ... on TrelloActionItemIntegrationSpecificDataNode {\n          __typename\n          externalCardId\n          boardName\n        }\n        ... on MondayActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalGroupName\n          externalBoardId\n          externalBoardName\n          status\n          mondayUser {\n            accountSlug\n            id\n          }\n        }\n        ... on LinearActionItemIntegrationSpecificDataNode {\n          __typename\n          externalIdentifier\n          teamName\n          statusName\n          statusColor\n          linearUser {\n            id\n            isConnected\n            organizationUrlKey\n          }\n        }\n        ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalListId\n          externalListName\n          status\n          microsoftTodoUser {\n            isConnected\n            id\n          }\n        }\n        ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          hubspotUrl\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  stream {\n    id\n    type\n    isExternal\n    account {\n      __typename\n      id\n    }\n  }\n  ...AttachmentsRelay_note\n}\n\nfragment MeetingContainerModalNote_viewer on Viewer {\n  uxSimplificationEnabled\n  user {\n    id\n    isGuest\n    firstName\n  }\n  account {\n    loomEnabled\n    tags {\n      __typename\n      id\n      label\n      color\n    }\n    billingAccount {\n      hasAccessToDuedates: hasAccessToFeature(feature: duedates)\n      hasAccessToVersioning: hasAccessToFeature(feature: versioning)\n      hasAccessToSharing: hasAccessToFeature(feature: sharing)\n      hasAccessToJiraIntegration: hasAccessToFeature(feature: jira_integration)\n      hasAccessToComments: hasAccessToFeature(feature: comments)\n      hasAccessToMeetingFeedback: hasAccessToFeature(feature: meeting_feedback)\n      hasAccessToNoteLocking: hasAccessToFeature(feature: note_locking)\n      hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n      hasAccessToEmbeds: hasAccessToFeature(feature: embeds)\n      hasAccessToSalesforce: hasAccessToFeature(feature: salesforce_integration)\n      hasAccessToHubspot: hasAccessToFeature(feature: hubspot_integration)\n      hasAccessToAsana: hasAccessToFeature(feature: asana_integration)\n      hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      hasAccessToNotesIntegrationExport: hasAccessToFeature(feature: notes_integration_export)\n      hasAccessToMultipleAssignees: hasAccessToFeature(feature: multiple_assignees)\n      featureAccess\n      id\n    }\n    integrations {\n      jira {\n        id\n        clientKey\n        baseUrl\n      }\n    }\n    id\n  }\n  connectedActionItemIntegrations\n  integrations {\n    asana {\n      isConnected\n      id\n    }\n  }\n}\n\nfragment MeetingContent_note on INote {\n  __isINote: __typename\n  id\n  __typename\n  ... on Note {\n    viewerCanEdit\n    eventGuid\n  }\n  ...utils_useMeetingRecorderStatus_note\n  ...TranscriptModalContent_note\n  ...TranscriptPanel_note\n  ...MeetingContainerModalNote_note\n  ...MeetingNote_note\n  ...useShouldShowRecapTab_note\n  ...MeetingHeader_note\n  ...FloatingRecordingControls_note\n  ...HighlightsPanel_note\n  ...StatsPanel_note\n}\n\nfragment MeetingContent_viewer on Viewer {\n  ...HighlightsPanel_viewer\n  ...MeetingContainerModalNote_viewer\n  ...MeetingNote_viewer\n  ...NoteHeader_viewer\n  ...MeetingPhaseContext_viewer\n  ...TranscriptPanel_Transcript_viewer\n  ...StatsPanel_viewer\n  ...MeetingHeader_viewer\n  ...PreMeetingControls_viewer\n  hasAccessToCopilot\n  account {\n    __typename\n    id\n    name\n    logo\n    allowRecapDownload\n    allowRecapEngagementStats\n  }\n  videoPlaybackSettings {\n    ...TranscriptVideo_videoPlaybackSettings\n    id\n  }\n}\n\nfragment MeetingDateOrTimer_note on Note {\n  id\n  createdAt\n  eventStart\n  eventEnd\n  noteType\n  viewerCanEdit\n  stream {\n    isExternal\n    id\n  }\n  event {\n    status\n    id\n  }\n  eventGuid\n  ...NoteTimeSelectorModal_note\n}\n\nfragment MeetingHeader_note on Note {\n  id\n  title\n  noteType\n  url\n  viewerCanEdit\n  stream {\n    id\n    ...SeriesSwitcher_stream\n  }\n  event {\n    guid\n    ...JoinConferenceButton_event\n    id\n  }\n  ...SeriesExplorer_note\n  ...MeetingDateOrTimer_note\n  ...Attendees_note\n  ...ShareButton_note\n  ...MoreActionsMenu_MeetingHeader_note\n}\n\nfragment MeetingHeader_viewer on Viewer {\n  ...SeriesSwitcher_viewer\n  ...JoinConferenceButton_viewer\n  ...Attendees_viewer\n  ...MoreActionsMenu_MeetingHeader_viewer\n}\n\nfragment MeetingInternalContent_meetingRecording on MeetingRecording {\n  __typename\n  id\n  title\n  url\n  subtitlesVttUrl\n  meetingRecordedVideoDuration\n  transcript\n  activeSummary {\n    id\n    summary\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n    }\n    decisions {\n      timestamp\n      text\n    }\n    activeRecapTemplate\n    templatedRecaps\n  }\n  clips {\n    id\n    clipStart\n    clipEnd\n    ...ClipsPanel_ClipSummary_clip\n  }\n  isGeneratingRecapTemplate\n  redactionIsInProgress\n  regenerationForLanguageIsInProgress\n  hasAskCopilotConversation\n  thumbnailVttUrl\n  meetingCallStart\n  meetingRecordedVideoUrl\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n  userVideoProgress\n  ownerAccount {\n    __typename\n    id\n  }\n  note {\n    __typename\n    title\n    id\n  }\n  ...ClipCutModal_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...HighlightsPanel_meetingRecording_1DbIRQ\n  ...ChaptersPanel_meetingRecording\n  ...TranscriptVideo_meetingRecording_1DbIRQ\n  ...ClipsPanel_meetingRecording\n  ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n  ...DislikeModal_meetingRecording\n  ...TranscriptModalContentStats\n  ...TranscriptModalGenerating_RedactingPreview_meetingRecording\n}\n\nfragment MeetingNote_note on Note {\n  id\n  title\n  url\n  eventGuid\n  rawDraftJson\n  updatedAt\n  createdAt\n  eventStart\n  eventEnd\n  finished\n  collapsedBlockKeys\n  isLocked\n  canUnlockNote\n  groupName\n  viewerCanEdit\n  comments {\n    blockKey\n    count\n    users {\n      id\n      fullName\n      image\n      isExternal\n    }\n  }\n  reactions\n  attachments {\n    id\n    dimensions {\n      height\n      width\n    }\n    ...AttachmentPreviewAttachment\n  }\n  noteuserSet {\n    id\n    lastSeenAt\n    user {\n      __typename\n      id\n      type\n      email\n      firstName\n      fullName\n      image\n      isActive\n      isConfigured\n      isGuest\n      isTopUser\n      isExternal\n      internalAttributes {\n        invitable\n        id\n      }\n    }\n  }\n  externalUsers {\n    __typename\n    id\n    type\n    email\n    firstName\n    fullName\n    image\n    isActive\n    isConfigured\n    isGuest\n    isTopUser\n    isExternal\n    internalAttributes {\n      invitable\n      id\n    }\n  }\n  linkedActionItems: actionItems(linkedOnly: true) {\n    hasOriginalBlock\n    originalBlockId\n    originalBlock {\n      key\n      id\n    }\n    id\n  }\n  asanaActionItems: actionItems(asanaOnly: true) {\n    blockId: id\n    blockKey: key\n    asanablocklink {\n      id\n      project {\n        id\n        name\n        externalId\n      }\n      externalId\n    }\n    id\n  }\n  integrationLinkedActionItems: actionItems(integrationConnectedOnly: true) {\n    id\n    key\n    actionItemIntegrationLink {\n      id\n      actionItem {\n        originalBlockId\n        id\n        key\n      }\n      createdAt\n      updatedAt\n      syncStatus\n      lastSyncedError\n      integrationProvider\n      integrationData {\n        __typename\n        ... on ClickupActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          listName\n          status\n          statusColor\n        }\n        ... on TrelloActionItemIntegrationSpecificDataNode {\n          __typename\n          externalCardId\n          boardName\n        }\n        ... on MondayActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalGroupName\n          externalBoardId\n          externalBoardName\n          status\n          mondayUser {\n            accountSlug\n            id\n          }\n        }\n        ... on LinearActionItemIntegrationSpecificDataNode {\n          __typename\n          externalIdentifier\n          teamName\n          statusName\n          statusColor\n          linearUser {\n            id\n            isConnected\n            organizationUrlKey\n          }\n        }\n        ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          externalListId\n          externalListName\n          status\n          microsoftTodoUser {\n            isConnected\n            id\n          }\n        }\n        ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n          __typename\n          externalTaskId\n          hubspotUrl\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  stream {\n    id\n    type\n    isExternal\n    account {\n      __typename\n      id\n    }\n  }\n  ...AttachmentsRelay_note\n}\n\nfragment MeetingNote_viewer on Viewer {\n  user {\n    id\n    isGuest\n    firstName\n  }\n  account {\n    loomEnabled\n    tags {\n      __typename\n      id\n      label\n      color\n    }\n    billingAccount {\n      hasAccessToDuedates: hasAccessToFeature(feature: duedates)\n      hasAccessToVersioning: hasAccessToFeature(feature: versioning)\n      hasAccessToSharing: hasAccessToFeature(feature: sharing)\n      hasAccessToJiraIntegration: hasAccessToFeature(feature: jira_integration)\n      hasAccessToComments: hasAccessToFeature(feature: comments)\n      hasAccessToMeetingFeedback: hasAccessToFeature(feature: meeting_feedback)\n      hasAccessToNoteLocking: hasAccessToFeature(feature: note_locking)\n      hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n      hasAccessToEmbeds: hasAccessToFeature(feature: embeds)\n      hasAccessToSalesforce: hasAccessToFeature(feature: salesforce_integration)\n      hasAccessToHubspot: hasAccessToFeature(feature: hubspot_integration)\n      hasAccessToAsana: hasAccessToFeature(feature: asana_integration)\n      hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      hasAccessToNotesIntegrationExport: hasAccessToFeature(feature: notes_integration_export)\n      hasAccessToMultipleAssignees: hasAccessToFeature(feature: multiple_assignees)\n      featureAccess\n      id\n    }\n    integrations {\n      jira {\n        id\n        clientKey\n        baseUrl\n      }\n    }\n    id\n  }\n  connectedActionItemIntegrations\n  integrations {\n    asana {\n      isConnected\n      id\n    }\n  }\n}\n\nfragment MeetingPhaseContext_note on Note {\n  id\n  groupName\n  event {\n    id\n    title\n    status\n    start\n    end\n    isAllDay\n    conferenceCalls {\n      provider\n      url\n    }\n    hasUsersWithExternalEmail\n  }\n  finished\n  eventGuid\n  url\n  account {\n    __typename\n    allowAiFeatures\n    id\n  }\n  stream {\n    id\n    schedulingMeetingAssistantAutomationIsActive\n  }\n  meetingRecordings {\n    id\n    status\n    externalRecordingProvider\n    meetingCallStart\n    mediaType\n    userWhoStartedRecording {\n      id\n      firstName\n    }\n  }\n  recordingErrorIndicator {\n    message\n    cancelledBy {\n      id\n      fullName\n      email\n    }\n    errorType\n    updatedAt\n  }\n  hasMeetingRecordings\n  ...utils_useAutoRefetchMeetingRecording_note\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n}\n\nfragment MeetingPhaseContext_viewer on Viewer {\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  hasAccessToScheduledMeetingRecordings\n  hasAdminAccess\n  account {\n    allowMeetingRecording\n    id\n  }\n  user {\n    id\n  }\n  meetingRecapAutoShareSettings {\n    id\n    sendTo\n  }\n}\n\nfragment MenuItemTooltip_useGetPropsForExternalWorkspaces_note on Note {\n  stream {\n    isExternal\n    account {\n      __typename\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment MergeSeries_note on Note {\n  stream {\n    id\n    displayName\n    notestreamusers {\n      user {\n        id\n      }\n      accessType\n      id\n    }\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment MergeSeries_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment MoreActionsMenuNote_viewer on Viewer {\n  user {\n    id\n    isGuest\n  }\n  account {\n    allowAiFeatures\n    id\n  }\n  ...SaveAsTemplate_viewer\n  ...VersionHistory_viewer\n  ...LockNote_viewer\n  ...DeleteMeeting_viewer\n}\n\nfragment MoreActionsMenu_MeetingHeader_note on Note {\n  id\n  title\n  isLocked\n  viewerCanEdit\n  hasMeetingRecordings\n  noteType\n  eventGuid\n  stream {\n    id\n    type\n  }\n  ...useCopyMeetingLink_note\n  ...AddNoteTitle_note\n  ...ApplyTemplate_note\n  ...EditTemplateMenuItem_note\n  ...SaveAsTemplate_note\n  ...RecapLanguage_note\n  ...SeriesSettings_note\n  ...CarryForward_MoreActionsMenu_note\n  ...MergeSeries_note\n  ...ExportMenuItem_note\n  ...VersionHistory_note\n  ...ResolvedComments_note\n  ...EditLinkedEvent_note\n  ...NotAOneOnOne_note\n  ...LockNote_note\n  ...DeleteMeeting_note\n  ...ShareSeries_note\n}\n\nfragment MoreActionsMenu_MeetingHeader_viewer on Viewer {\n  account {\n    allowAiFeatures\n    id\n  }\n  user {\n    isGuest\n    id\n  }\n  ...SaveAsTemplate_viewer\n  ...MergeSeries_viewer\n  ...ExportMenuItem_viewer\n  ...VersionHistory_viewer\n  ...UploadMenuItem_viewer\n  ...LockNote_viewer\n  ...DeleteMeeting_viewer\n  ...ShareSeries_viewer\n}\n\nfragment NotAOneOnOne_note on Note {\n  id\n}\n\nfragment NoteHeader_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n  ...RecordingControls_viewer\n  ...JoinConferenceButton_viewer\n  ...MoreActionsMenuNote_viewer\n}\n\nfragment NoteTimeSelectorModal_note on Note {\n  id\n  createdAt\n  eventStart\n  eventEnd\n}\n\nfragment Notes_note on Note {\n  id\n  stream {\n    id\n    type\n  }\n  meetingRecordings {\n    id\n    title\n    meetingCallStart\n    meetingCallEnd\n    meetingVideoAndTranscriptionDownloadUrl\n    meetingRecordedVideoUrl\n    subtitlesVttUrl\n    thumbnailVttUrl\n    isFavourite\n    viewerCanDelete\n    hasExternalAttendees\n    transcript\n    transcriptDeletionReason\n    isCurrentlyRecording\n    activeSummary {\n      id\n    }\n    clips {\n      id\n      ...ClipsPanel_ClipSummary_clip\n    }\n    ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n    ...MeetingInternalContent_meetingRecording\n    ...TranscriptVideo_meetingRecording_1DbIRQ\n    ...ClipCutModal_meetingRecording\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...utils_AddedOrAvailableUntil_meetingRecording\n    ...utils_useGetURL_recording\n    ...RecapHistory_meetingRecording\n    ...Timeline_meetingKeyEvents\n    ...HighlightsPanel_meetingRecording_1DbIRQ\n    ...ChaptersPanel_meetingRecording\n    ...ClipsPanel_meetingRecording\n    ...useMeetingRecordingWebsocket_meetingRecording\n    ownerAccount {\n      __typename\n      id\n    }\n    mediaType\n  }\n  ...MeetingPhaseContext_note\n  ...MeetingContent_note\n}\n\nfragment Notes_viewer on Viewer {\n  ...MeetingPhaseContext_viewer\n  ...MeetingContent_viewer\n}\n\nfragment OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment OptionsMenu_note on Note {\n  stream {\n    id\n    schedulingMeetingAssistantAutomationIsActive\n    ...OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason\n  }\n  event {\n    mainConferenceCall {\n      provider\n    }\n    conferenceCalls {\n      provider\n    }\n    id\n  }\n}\n\nfragment OptionsMenu_viewer on Viewer {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer\n}\n\nfragment PreMeetingControls_note on Note {\n  event {\n    conferenceCalls {\n      provider\n      url\n    }\n    id\n  }\n  stream {\n    id\n    recordingMediaType\n    recordingMode\n  }\n  ...AutoSendToEveryone_autoShareIsSetToEveryone_note\n  ...AutoRecordToggle_note\n  ...OptionsMenu_note\n}\n\nfragment PreMeetingControls_viewer on Viewer {\n  ...AutoRecordToggle_viewer\n  ...OptionsMenu_viewer\n}\n\nfragment RecapHistory_meetingRecording on MeetingRecording {\n  id\n  meetingRecordedVideoDuration\n  activeSummary {\n    id\n  }\n  summaries {\n    id\n    summary\n    createdAt\n    actionItems {\n      timestamp\n      text\n      assignees {\n        userId\n        fullName\n      }\n      insertedBlockKey\n      edited\n    }\n    chapters {\n      timestamp\n      title\n      bulletPoints {\n        text\n        timestamp\n        textShort\n        context\n      }\n    }\n    decisions {\n      ...HighlightsPanel_DecisionsHighlight_decisions\n    }\n    creator {\n      id\n      fullName\n      email\n      image\n    }\n  }\n}\n\nfragment RecapLanguage_note on Note {\n  id\n  viewerCanEdit\n  isLocked\n  stream {\n    isExternal\n    id\n  }\n  meetingRecordings {\n    id\n    viewerCanDelete\n    ...RecapHistory_meetingRecording\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment RecordingControls_viewer on Viewer {\n  hasAccessToCopilot\n  ...StartAndAutoRecordingControls_viewer\n}\n\nfragment RegenerateForLanguageModalFragment_meetingRecording on MeetingRecording {\n  id\n  detectedLanguage\n  languageConfidenceScore\n  canRegenerateSummary\n  regenerationForLanguageIsInProgress\n}\n\nfragment ResolvedComments_note on Note {\n  id\n}\n\nfragment SaveAsTemplate_note on Note {\n  id\n  title\n  stream {\n    id\n  }\n  rawDraftJson\n  schemaVersion\n}\n\nfragment SaveAsTemplate_viewer on Viewer {\n  canCreateWorkspaceTemplate\n  account {\n    billingAccount {\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      id\n    }\n    id\n  }\n}\n\nfragment SeriesExplorer_note on Note {\n  id\n  stream {\n    id\n    nextEvent {\n      start\n      end\n      isAllDay\n      id\n    }\n  }\n  previousNote {\n    id\n    createdAt\n    eventStart\n    url\n    event {\n      isAllDay\n      id\n    }\n  }\n}\n\nfragment SeriesSettings_note on Note {\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment SeriesSidePanel_allowedTabs_stream on NoteStream {\n  isExternal\n  notestreamusers {\n    user {\n      email\n      id\n    }\n    id\n  }\n  claimedEvents {\n    attendees {\n      email\n    }\n    id\n  }\n  noteWithRecordingExists\n  askCopilotConversationExists\n}\n\nfragment SeriesSidePanel_allowedTabs_viewer on Viewer {\n  integrations {\n    hubspot {\n      isConnected\n      id\n    }\n    salesforce {\n      isConnected\n      enhancedNotesEnabled\n      id\n    }\n  }\n  account {\n    emailDomainList\n    integrations {\n      hubspot {\n        userConnected\n        id\n      }\n    }\n    allowAiFeatures\n    billingAccount {\n      hasAccessToHubspotFeature: hasAccessToFeature(feature: hubspot_integration)\n      hasAccessToSalesforceFeature: hasAccessToFeature(feature: salesforce_integration)\n      id\n    }\n    id\n  }\n}\n\nfragment SeriesSwitcherOption_stream on NoteStream {\n  id\n  displayName\n  url\n  account {\n    __typename\n    id\n    logo\n    name\n  }\n}\n\nfragment SeriesSwitcher_ExternalStreamTooltip_stream on NoteStream {\n  id\n  isExternal\n  account {\n    __typename\n    name\n    id\n  }\n  relatedStreams {\n    id\n    isExternal\n    account {\n      __typename\n      name\n      id\n    }\n  }\n}\n\nfragment SeriesSwitcher_stream on NoteStream {\n  isExternal\n  account {\n    __typename\n    id\n    image: logo\n    name\n  }\n  ...SeriesSwitcher_ExternalStreamTooltip_stream\n  ...SeriesSwitcherOption_stream\n  relatedStreams {\n    id\n    isExternal\n    account {\n      __typename\n      id\n      name\n    }\n    ...SeriesSwitcherOption_stream\n  }\n}\n\nfragment SeriesSwitcher_viewer on Viewer {\n  account {\n    id\n  }\n}\n\nfragment ShareButton_note on Note {\n  id\n  noteType\n  stream {\n    id\n  }\n}\n\nfragment ShareSeries_note on Note {\n  stream {\n    id\n    displayName\n    owner {\n      id\n    }\n    notestreamusers {\n      id\n      accessType\n      user {\n        id\n        email\n        image\n        fullName\n        lastName\n        firstName\n        isActive\n        isConfigured\n        isGuest\n        hasReceivedInvites\n        isTopUser\n        isExternal\n        account {\n          __typename\n          id\n          name\n        }\n      }\n    }\n  }\n  ...MenuItemTooltip_useGetPropsForExternalWorkspaces_note\n}\n\nfragment ShareSeries_viewer on Viewer {\n  user {\n    id\n  }\n  account {\n    billingAccount {\n      hasAccessToSharing: hasAccessToFeature(feature: sharing)\n      id\n    }\n    id\n  }\n}\n\nfragment StartAndAutoRecordingControls_viewer on Viewer {\n  hasAccessToCopilot\n  meetingRecapAutoShareSettings {\n    id\n    sendTo\n  }\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer\n}\n\nfragment StatsPanel_note on Note {\n  eventStart\n  eventEnd\n  account {\n    __typename\n    allowRecapEngagementStats\n    id\n  }\n}\n\nfragment StatsPanel_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_stream on NoteStream {\n  autoRecordSetting {\n    __typename\n    ... on NoteStreamStreamBasedAutoRecordSource {\n      value\n      creator {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n    }\n    ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n      users {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n      rules {\n        ruleLevel\n        autoRecordRuleUsers {\n          user {\n            id\n            firstName\n            fullName\n            isViewer\n          }\n        }\n        id\n      }\n      cannotBeRecordedReason\n    }\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer on Viewer {\n  hasAccessToCopilot\n}\n\nfragment Timeline_meetingKeyEvents on MeetingRecording {\n  meetingKeyEvents {\n    eventType\n    participantName\n    timeFromRecordingStart\n    endTimeFromRecordingStart\n    duration\n  }\n  comments {\n    threadId\n    startTimestamp\n  }\n}\n\nfragment TranscriptModalContentStats on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n  meetingStats {\n    userStats {\n      email\n      fullName\n      image\n      isGuest\n      isTopUser\n      absent\n      totalTalkTime\n      percentage\n      joinedAt\n      leftAt\n    }\n    actualStartTime\n    actualEndTime\n  }\n  id\n}\n\nfragment TranscriptModalContent_note on Note {\n  id\n  __typename\n  viewerCanEdit\n  ...TranscriptPanel_note\n}\n\nfragment TranscriptModalGenerating_RedactingPreview_meetingRecording on MeetingRecording {\n  mediaType\n}\n\nfragment TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    id\n    detectedLanguage\n    languageConfidenceScore\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    allRelevantParticipants {\n      ...TranscriptPanel_SpeakerRelabelForm_attendees\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      allRelevantParticipants {\n        ...TranscriptPanel_SpeakerRelabelForm_attendees\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_SpeakerRelabelForm_attendees on RecordingParticipant {\n  email\n  fullName\n  image\n  isTopUser\n  user {\n    id\n  }\n}\n\nfragment TranscriptPanel_TranscriptSegment_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  id\n  ownerAccount {\n    __typename\n    id\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptPanel_TranscriptSegment_note on Note {\n  id\n}\n\nfragment TranscriptPanel_Transcript_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    activeSummary {\n      id\n    }\n    canRegenerateSummary\n    comments {\n      threadId\n      startTimestamp\n      endTimestamp\n      count\n      users {\n        id\n        email\n        fullName\n        image\n        isExternal\n      }\n    }\n    showLowLanguageConfidenceRegenerationBanner\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment TranscriptPanel_Transcript_viewer on Viewer {\n  account {\n    allowAiFeatures\n    allowMeetingRecordingRedaction\n    billingAccount {\n      hasAccessToRedaction: hasAccessToFeature(feature: redaction)\n      hasAccessToRecapComments: hasAccessToFeature(feature: recap_comments)\n      hasAccessToPrivateRecapComments: hasAccessToFeature(feature: recap_private_comments)\n      id\n    }\n    id\n  }\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    ... on MeetingRecordingInterface {\n      __isMeetingRecordingInterface: __typename\n      ... on MeetingRecording {\n        allRelevantParticipants {\n          fullName\n          email\n          image\n          isTopUser\n          user {\n            id\n          }\n        }\n      }\n      ... on MeetingRecordingClip {\n        baseRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      ... on MeetingRecordingInterface {\n        __isMeetingRecordingInterface: __typename\n        ... on MeetingRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n        }\n        ... on MeetingRecordingClip {\n          baseRecording {\n            allRelevantParticipants {\n              fullName\n              email\n              image\n              isTopUser\n              user {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_note on Note {\n  id\n  isLocked\n  viewerCanEdit\n  noteuserSet {\n    id\n    user {\n      id\n      email\n      fullName\n      isGuest\n      image\n    }\n  }\n  event {\n    organizer {\n      id\n    }\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_note\n}\n\nfragment TranscriptVideo_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  ... on MeetingRecording {\n    userVideoProgress\n    clips {\n      id\n    }\n    didViewerAttend\n  }\n  ...Video_meetingRecording\n}\n\nfragment TranscriptVideo_videoPlaybackSettings on UserVideoPlaybackSettings {\n  id\n  playbackRate\n  subtitlesEnabled\n  volume\n  muted\n}\n\nfragment UploadMenuItem_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  account {\n    billingAccount {\n      subscriptionBillingCycleAnchor\n      id\n    }\n    uploadCredits {\n      includedUploadCredits\n      includedCreditsUsedCurrentCycle\n    }\n    id\n  }\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  ...BillingIdentityFeaturesPaywall_viewer\n}\n\nfragment VersionHistory_note on Note {\n  id\n  hasMeetingRecordings\n  meetingRecordings {\n    id\n    ...RecapHistory_meetingRecording\n  }\n}\n\nfragment VersionHistory_viewer on Viewer {\n  account {\n    billingAccount {\n      hasAccessToVersioning: hasAccessToFeature(feature: versioning)\n      id\n    }\n    id\n  }\n}\n\nfragment Video_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  createdAt\n  isFavourite\n  meetingRecordedVideoUrl\n  transcriptTxtDownloadUrl\n  meetingRecordedVideoPosterUrl\n  viewCount\n  mediaType\n  ... on MeetingRecording {\n    meetingCallEnd\n    aiArtifactsTxtDownloadUrl\n    activeSummary {\n      chapters {\n        timestamp\n        title\n        bulletPoints {\n          text\n          timestamp\n          textShort\n          context\n        }\n      }\n      id\n    }\n    ...Timeline_meetingKeyEvents\n  }\n}\n\nfragment featureFlag_useCopilotPaywallsOn_viewer on Viewer {\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n}\n\nfragment useCopyMeetingLink_note on Note {\n  id\n  hasMeetingRecordings\n  meetingRecordingLink {\n    id\n    urlForCopy: url(forCopy: true)\n  }\n  shortUrl\n}\n\nfragment useEventState_stream on NoteStream {\n  linkedEventGuid\n  linkedEvent {\n    nextOccurrence {\n      start\n      end\n      id\n    }\n    finalOccurrence\n    id\n  }\n}\n\nfragment useMeetingRecordingWebsocket_meetingRecording on MeetingRecording {\n  id\n  title\n  redactionIsInProgress\n  isGeneratingRecapTemplate\n  regenerationForLanguageIsInProgress\n  ...DislikeModal_meetingRecording\n}\n\nfragment useShouldShowRecapTab_note on Note {\n  hasMeetingRecordings\n  meetingRecordings {\n    isCurrentlyRecording\n    id\n  }\n  ...utils_useMeetingRecorderStatus_note\n}\n\nfragment utils_AddedOrAvailableUntil_meetingRecording on MeetingRecording {\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n}\n\nfragment utils_useAutoRefetchMeetingRecording_note on Note {\n  id\n  finished\n  groupName\n  meetingRecordings {\n    id\n    meetingCallStart\n    status\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n\nfragment utils_useLongestMeetingRecording_meetingRecordings on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n}\n\nfragment utils_useMeetingRecorderStatus_note on Note {\n  groupName\n}\n"
  }
};
})();

(node as any).hash = "e2f7e38dd30c209a386c2ace0117cedb";

export default node;
